/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-29 19:49:33
 * @Description: 
 */

import React from "react";
import "./header.scss"
import { autorun } from "mobx"
import { FotorLinkToAICG, FotorLogoIcon, FotorLogoIconNew } from "src/assets"
import { Menu, Dropdown } from 'antd';
import FTUserStore from "src/store/FTUserStore";
import urls from "src/constant/url";
import FTLang from "src/utils/FTLang";
import BtnOpenApp from "src/components/BtnOpenApp";
import utils from "src/utils";
import FTAnalytic from "src/analyze/FTAnalytic";

const Logout = (e: any) => {
  e.stopPropagation();
  e.preventDefault();
  FTUserStore.loginOut()
}


class Header extends React.Component {
  state = {
    isLogin: false,
    isAndroidOriOS: false,
  }
  componentDidMount() {
    autorun(() => {
      let { userInfo } = FTUserStore
      let { ios, android } = utils.myBrowserOS();
      this.setState({
        isAndroidOriOS: ios|| android,
        isLogin: !!userInfo
      })
    })

  }

  handleSign = () => {
    FTUserStore.showLogin({
      isSignIn: true,
      options: {
        position: "goart_signin"
      },
      isShowScenses: true,
      otherParam: {
        scenesId: "014"
      }
    })
  }

  handleSignUp = () => {
    FTUserStore.showLogin({
      isSignIn: false,
      options: {
        position: "goart_signup"
      },
      isShowScenses: true,
      otherParam: {
        scenesId: "014"
      }
    })
  }

  handleLinkToAICG = () => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$project_top_feature',
      label: {
        location: "goart",
        button_position: "aiimage"
      }
    })
    window.open(process.env.REACT_APP_BASE_URL + "features/ai-image-generator/")
  }

  render() {
    let { isLogin, isAndroidOriOS } = this.state
    return <div className="header">
      <div className="header_left">
        <FotorLogoIconNew />
        <div className="link_to_aicg" onClick={() => this.handleLinkToAICG()}>
          <FotorLinkToAICG />
          <span className="link_to_aicg_text">
            {FTLang._("text_to_image")}
          </span>
        </div>
      </div>
      <div className="header_right">
        {
          isAndroidOriOS && <div className="header_right_item">
            <BtnOpenApp></BtnOpenApp>
          </div>
        }
        {isLogin ?

          <div className="header_right_item">
            <Dropdown overlayClassName="header_right_dropdown" overlay={<Menu>
              <Menu.Item key="user">
                <div className="header_right_user">
                  <div className="header_right_user_img">
                    <img src={FTUserStore.userInfo.headerUrl} alt="" />
                  </div>
                  <div className="header_right_user_info">
                    <span className="header_right_user_info_name">{
                      FTUserStore.userInfo.nickName
                    }</span>
                    <span className="header_right_user_info_email">{
                      FTUserStore.userInfo.email
                    }</span>
                  </div>
                </div>
              </Menu.Item>
              <Menu.Item key="accout">
                <a className="header_right_logout" href={urls.baseUrl + "user/settings"} target="_blank" rel="noreferrer">{FTLang._("goart_myaccount")}</a>
              </Menu.Item>
              <Menu.Item key="logout">
                <span className="header_right_logout" onClick={Logout}>{FTLang._("goart_logout")}</span>
              </Menu.Item>
            </Menu>} trigger={['click']}>
              <img src={FTUserStore.userInfo.headerUrl} alt="" />
            </Dropdown>
          </div>
            : (isAndroidOriOS ? <>
              <div className="header_right_item">
                <div className="header_right_noLogin">
                  <span className="header_right_signin" onClick={() => this.handleSign()}> {FTLang._("goart_signin")} </span>
                </div>
              </div></> :
            <div className="header_right_item">
              <div className="header_right_noLogin">
                <span className="header_right_signin" onClick={() => this.handleSign()}> {FTLang._("goart_signin")} </span>
                <span className="header_right_slider">/</span>
                <span className="header_right_signup" onClick={() => this.handleSignUp()}> {FTLang._("goart_signup")} </span>
              </div>
            </div>
            )
          }
      </div>
    </div>
  }
}


export default Header
